module.exports = __webpack_public_path__ + "img/rouge-2.2485926a.png";